import axios from 'axios';
import { useMutation, useQuery } from 'react-query';
import { API_URL } from '../Constants';
import { usePostTableData } from './services/postCall';

//add external contact
const addExternalContact = (values) => {
  return axios.post(API_URL + `/api/ExternalContact/ExternalContact`, values, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  });
};

export const useAddExternalContact = () => {
  return useMutation(addExternalContact);
};

//get External Contact

export const useFetchExternalContact = (data) => {
  return usePostTableData(
    data,
    `/api/ExternalContact/GetExternalContacts/${data?.isBlock}`,
    'externalContacts'
  );
};

//get external contact by id
const fetchExternalContactById = async ({ id }) => {
  if (id) {
    return await axios.get(
      API_URL + `/api/ExternalContact/GetExternalContactsById/${id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );
  }
};

export const useFetchExternalContactById = ({ id }) => {
  return useQuery({
    queryKey: [`edit-externalContact-${id}`],
    queryFn: () => fetchExternalContactById({ id }),
    enabled: false,
  });
};

//delete by id external contact by id
const deleteExternalContactById = (contactId) => {
  return axios.post(
    API_URL + `/api/ExternalContact/DeleteExternalContact/${contactId}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    }
  );
};

export const useDeleteExternalContactById = () => {
  return useMutation(deleteExternalContactById);
};

//block and unblock
const blockUnblockExternalContact = ({ contactId, isBlock }) => {
  return axios.post(
    API_URL +
      `/api/ExternalContact/BlockExternalContact/${contactId}/${isBlock}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    }
  );
};

export const useBlockUnblockExternalContact = () => {
  return useMutation(blockUnblockExternalContact);
};

////export external contact options
const exportExternalContacts = async () => {
  return await axios.get(API_URL + `/api/Export/ExportExternalContact`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    responseType: 'blob',
  });
};
export const useExportExternalContact = () => {
  return useMutation(() => exportExternalContacts());
};

//block and unblock
const uploadBulk = (formData) => {
  return axios.post(
    `${API_URL}/api/ExternalContact/external-contacts/import`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'multipart/form-data',
      },
    }
  );
};

export const useUploadBulk = () => {
  return useMutation((formData) => uploadBulk(formData));
};
